import { Link } from 'react-router-dom';
import { articleLinks } from '@/mocks/categories';

export default function ArticleHub() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
              Learning Hub
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Fresh Guides
              <br />
              <span className="italic font-light text-foreground-700">From Our Team</span>
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg leading-relaxed">
            Dive into our collection of expert-written guides covering everything from beginner setup to advanced bulk-ordering strategies. Each guide is crafted to help you get the most from your OOPBuy Spreadsheet workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articleLinks.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-3">
                  Guide
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  Read Article
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}